"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _withResponsive = _interopRequireDefault(require("01_core/hooks/withResponsive"));
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _useMediaQuery = _interopRequireDefault(require("@mui/material/useMediaQuery"));
var _labelConsts = require("../../../constants/labelConsts");
var _CSelect = _interopRequireDefault(require("../../materials/CSelect"));
var _ShowAllSwitch = _interopRequireDefault(require("../../materials/ShowAllSwitch"));
var _SafeGrid = _interopRequireDefault(require("01_core/components/materials/SafeGrid"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const BUTTON_HEIGHT = 40;
const BUTTON_MIN_WIDTH = 40;
const BORDER_COLOR = '#CCCCCC';
const BORDER = "1px solid ".concat(BORDER_COLOR);
const RADIUS = 6;
const ButtonArea = (0, _styles.styled)('div')(_ref => {
  let {
    totalPages
  } = _ref;
  return {
    display: 'inline-block',
    '& > button:first-of-type': {
      borderRadius: "".concat(RADIUS, "px 0 0 ").concat(RADIUS, "px")
    },
    '& > button:last-child': {
      borderRadius: totalPages === 1 ? "".concat(RADIUS, "px") : "0 ".concat(RADIUS, "px ").concat(RADIUS, "px 0"),
      borderRight: BORDER
    }
  };
});
const PageButton = (0, _styles.styled)('button', {
  shouldForwardProp: prop => prop !== 'current' && prop !== 'single'
})(_ref2 => {
  let {
    theme,
    current,
    single
  } = _ref2;
  return {
    background: current ? theme.palette.accent.main : theme.palette.accent.contrastText,
    borderTop: BORDER,
    borderBottom: BORDER,
    borderLeft: BORDER,
    borderRight: 0,
    color: current ? theme.palette.accent.contrastText : theme.palette.accent.main,
    cursor: current ? 'default' : 'pointer',
    height: BUTTON_HEIGHT,
    minWidth: BUTTON_MIN_WIDTH,
    display: 'inline-block',
    borderRadius: single ? "".concat(RADIUS, "px") : 0
  };
});

/**
 * ページング部品
 * @param {number} limit -1ページごとの件数
 * @param {number} total -合計件数
 * @param {number} currentPage -現在のページ数
 * @param {func} handleChangePage - currentPageの変更 <br/>
 * シグネチャ:(  page: number, pure:bool ): void
 * @param {func} handleViewNumChange - viewNumの変更
 * シグネチャ:(  viewNum: number ): void
 */
const Pagination = props => {
  const handleChangePage = page => {
    props.handleChangePage(page - 1);
  };
  const handleViewNumChange = viewNum => {
    props.handleChangePage(Math.floor((props.limit * props.currentPage + 1) / viewNum));
    props.handleViewNumChange(viewNum);
  };
  const {
    intl,
    limit,
    total
  } = props;
  const theme = (0, _styles.useTheme)();
  const isSmall = (0, _useMediaQuery.default)(theme.breakpoints.down('sm')); // sm以下ならtrue
  const isSmUp = (0, _useMediaQuery.default)(theme.breakpoints.up('sm')); // sm以上ならtrue
  const isMdUp = (0, _useMediaQuery.default)(theme.breakpoints.up('md')); // md以上ならtrue
  const MAX_PAGINATION = isSmall ? 3 : 5;
  if (limit * props.currentPage >= total) {
    props.handleChangePage(Math.ceil(total / limit) - 1, true);
  }
  const currentPage = props.currentPage + 1;
  const viewNumList = () => {
    return [{
      displayName: intl.formatMessage({
        id: _labelConsts.LABEL.CORE_VIEW_NUM_LIST
      }, {
        0: 50
      }),
      value: 50
    }, {
      displayName: intl.formatMessage({
        id: _labelConsts.LABEL.CORE_VIEW_NUM_LIST
      }, {
        0: 100
      }),
      value: 100
    }, {
      displayName: intl.formatMessage({
        id: _labelConsts.LABEL.CORE_VIEW_NUM_LIST
      }, {
        0: 150
      }),
      value: 150
    }];
  };
  const DisplayedResults = props2 => {
    const {
      dataLength,
      viewNum,
      currentPage
    } = props2;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
      align: "left",
      variant: "body2"
    }, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_LIST_COUNT_DISP_ALL
    }, {
      0: intl.formatNumber(dataLength)
    })), /*#__PURE__*/_react.default.createElement(_material.Typography, {
      variant: "body2"
    }, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_LIST_COUNT_DISP_DETAIL
    }, {
      0: intl.formatNumber(viewNum * currentPage + 1),
      1: intl.formatNumber(viewNum * (currentPage + 1) < dataLength ? viewNum * (currentPage + 1) : dataLength)
    })));
  };
  const totalPages = Math.max(1, Math.ceil(total / limit));
  const cp = currentPage;
  const hasPreviousPage = cp > 1;
  const hasNextPage = cp < totalPages;
  const previousPage = hasPreviousPage ? cp - 1 : 1;
  const nextPage = hasNextPage ? cp + 1 : totalPages;
  const singlePage = totalPages === 1;
  let start = Math.max(1, cp - Math.floor(MAX_PAGINATION / 2));
  let end = start + MAX_PAGINATION - 1;
  if (end > totalPages) {
    end = totalPages;
    start = Math.max(1, end - MAX_PAGINATION + 1);
  }
  const pages = [];
  for (let p = start; p <= end; p++) {
    pages.push(p);
  }
  return /*#__PURE__*/_react.default.createElement(_SafeGrid.default, {
    container: true,
    alignItems: "center",
    alignContent: "center",
    justifyContent: "space-between",
    spacing: 1
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    size: {
      xs: 12,
      sm: 3,
      md: 3
    }
  }, /*#__PURE__*/_react.default.createElement(DisplayedResults, {
    dataLength: total,
    viewNum: limit,
    currentPage: props.currentPage
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    size: {
      xs: 12,
      sm: 7,
      md: 5
    },
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement(ButtonArea, {
    totalPages: totalPages
  }, cp > 1 ? /*#__PURE__*/_react.default.createElement(PageButton, {
    onClick: () => handleChangePage(1),
    disabled: cp === 1,
    type: "button"
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    color: "inherit",
    variant: "body2"
  }, '<<')) : null, hasPreviousPage ? /*#__PURE__*/_react.default.createElement(PageButton, {
    onClick: () => handleChangePage(previousPage),
    type: "button"
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    color: "inherit",
    variant: "body2"
  }, '<')) : null, pages.map(page => /*#__PURE__*/_react.default.createElement(PageButton, {
    key: page,
    current: cp === page,
    single: singlePage,
    onClick: () => handleChangePage(page),
    type: "button"
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    color: "inherit",
    variant: "body2"
  }, page))), hasNextPage && cp < totalPages ? /*#__PURE__*/_react.default.createElement(PageButton, {
    onClick: () => handleChangePage(nextPage),
    type: "button"
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    color: "inherit",
    variant: "body2"
  }, '>')) : null, cp < totalPages ? /*#__PURE__*/_react.default.createElement(PageButton, {
    onClick: () => handleChangePage(totalPages),
    type: "button"
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    color: "inherit",
    variant: "body2"
  }, '>>')) : null)), isSmUp ? /*#__PURE__*/_react.default.createElement(_material.Grid, {
    size: {
      sm: 2,
      md: 2
    }
  }, props.changeShowAll ? /*#__PURE__*/_react.default.createElement(_ShowAllSwitch.default, {
    showAll: props.showAll,
    changeShowAll: props.changeShowAll,
    labelText: props.showAllLabel
  }) : null) : null, isMdUp ? /*#__PURE__*/_react.default.createElement(_material.Grid, {
    size: {
      md: 2
    }
  }, /*#__PURE__*/_react.default.createElement(_CSelect.default, {
    value: limit,
    setNone: false,
    onChange: handleViewNumChange,
    items: viewNumList()
  })) : null);
};
Pagination.propTypes = {
  limit: _propTypes.default.number.isRequired,
  total: _propTypes.default.number.isRequired,
  currentPage: _propTypes.default.number.isRequired
};
var _default = exports.default = (0, _withResponsive.default)((0, _reactIntl.injectIntl)(Pagination));